'use client';
import { Stack, StackProps } from '@mantine/core';
import { NameValuePair } from '@/app/assets/details/atoms/NameValuePair';
import { RapidModel } from '@/types/rapidModel';
import { getDateTimeStringInUsersTimezone } from '@/utils/dateTimeUtils';
import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { RawModel } from '@/types/rawModel';

interface FileInformationProps extends StackProps {
  asset: RapidModel | RawModel;
}

export function FileInformation({ asset, ...props }: FileInformationProps) {
  const extensions =
    asset.assetType === 'raw'
      ? [asset.format]
      : Object.keys(asset.downloads ?? {}).filter((item) => item !== 'all');

  const assetSize =
    asset.assetType === 'raw' ? asset.size : asset.meta?.size ?? 0;

  return (
    <CollapsibleSection title='File Information'>
      <Stack {...props} gap={2}>
        <NameValuePair name='File ID:' value={asset.id.toString()} />
        <NameValuePair name='Type:' value={extensions ?? ''} />
        <NameValuePair
          name='Size:'
          value={`${(assetSize / 1024 / 1024).toFixed(2)} MB`}
        />
        <NameValuePair
          name='Created at:'
          value={getDateTimeStringInUsersTimezone(asset.created_at)}
        />
        {asset.assetType === 'output' && (
          <NameValuePair
            name='3D Processor Preset:'
            value={asset.preset_name}
          />
        )}
      </Stack>
    </CollapsibleSection>
  );
}
